import React, { useState, useCallback, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import { API, defaultLimitPagination, get } from "../../../config";
import moment from "moment";
import Spin from "../../common/Spin";

import Pagination from "../../common/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import ImportLogDetail from "./ImportLogDetail";
// import NotImportedDelete from "./NotImportedDelete";
import { debounce } from "underscore";
import SearchBox from "../../common/SearchBox";
import { formatNumber } from "../../common/Misc";
import { toast } from "react-toastify";
import axios from "axios";
import { useProject } from "../../common/ProjectContext";
import PaymentClaimStatus from "../payment-claim/components/PaymentClaimStatus";
import { Modal } from "react-bootstrap";
import Upload from "../payment-claim/Upload";

const NotImportedLogs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const [notImportLogs, setNotImportLogs] = useState({});
  const [loading, setLoading] = useState(false);
  const [notImportLogId, setNotImportLogId] = useState();
  const [importLogModal, setImportLogModal] = useState(false);
  const search = query.get("search");
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");

  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const [sortField, setSortField] = useState("post_date");
  const [sortOrder, setSortOrder] = useState("DESC");
  const params = useParams();
  const projectId = params?.project_id;
  const [showEdit, setShowEdit] = useState(false);

  // const trustType = params?.trust_type;
  const trust_type = 1;

  const { ProjectReadOnly } = useProject();

  const toggleShowModal = () => {
    setImportLogModal(!importLogModal);
  };

  const handleDetails = (id) => {
    setNotImportLogId(id);
    setImportLogModal(true);
  };

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC"
      );
    }
  };

  const downloadLetter = async (path) => {
    try {
      if (path) {
        const response = await axios.get(`${path}`, {
          responseType: "blob",
        });
        const fileData = response.data;
        const url = window.URL.createObjectURL(new Blob([fileData]));
        var a = document.createElement("a");
        a.href = url;
        var file = path.split("/");
        a.setAttribute("download", file[file.length - 1] || "new_aba.aba");
        document.body.appendChild(a);
        a.click();
        a.remove();
      } else {
        toast.error("File does not exist.");
      }
    } catch (e) {
      const errors = e.response?.data?.errors;
      Object.keys(errors).forEach((key) => {
        toast.error(errors[key][0]);
      });
    }
  };

  // *API Call for Import Logs List - Start
  const fetchNotImportedLogs = useCallback(
    async (passLimit, passPage) => {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.PAYMENT_CLAIM_IMPORT_LOGS}?builder_project_id=${
            projectId ? projectId : ""
          }&trust_type=${trust_type}&limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}&status=0&search=${
            searchParam ? searchParam : ""
          }&sort_column=${sortField ? sortField : ""}&sort_order=${
            sortOrder ? sortOrder : ""
          }`
        );
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        setTotal(data?.data?.total);
        setNotImportLogs(data?.data?.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [projectId, trust_type, searchParam, sortField, sortOrder]
  );

  useEffect(() => {
    fetchNotImportedLogs();
  }, [fetchNotImportedLogs]);
  // *API Call for Import Logs List - End

  useEffect(() => {
    navigate(
      `/projects/${projectId}/payment-claim-import-logs?tab=not-imported&limit=${
        limit ? limit : defaultLimitPagination
      }&page=${page ? page : 1}&search=${
        searchParam ? searchParam : ""
      }&sort_column=${sortField ? sortField : ""}&sort_order=${
        sortOrder ? sortOrder : ""
      }`,
      { replace: true }
    );
  }, [navigate, projectId, page, limit, searchParam, sortField, sortOrder]);

  // const handleDelete = () => {
  //   fetchNotImportedLogs();
  // };

  const toggleEditModal = (id) => {
    setNotImportLogId(id);
    setShowEdit(!showEdit);
  };

  // *Import Logs List Table Row and Column Generation, Filtering and Sorting of Record, Select Row and Expand Row - Start
  const notImportLogsGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      let contactDetails = JSON.parse(notImportLogs[i]?.Contact);
      let creditNotes = JSON.parse(notImportLogs[i]?.CreditNotes);
      items.push({
        key: notImportLogs[i]?.id,
        id: notImportLogs[i]?.id ? notImportLogs[i]?.id : "",
        payment_claim_to: contactDetails?.Name
          ? `${contactDetails?.Name} ${
              contactDetails?.FirstName && contactDetails?.LastName
                ? "(" +
                  contactDetails?.FirstName +
                  " " +
                  contactDetails?.LastName +
                  ")"
                : !contactDetails?.FirstName && contactDetails?.LastName
                ? "(" + contactDetails?.LastName + ")"
                : ""
            }`
          : contactDetails?.FirstName && contactDetails?.LastName
          ? contactDetails?.FirstName + " " + contactDetails?.LastName
          : !contactDetails?.FirstName && contactDetails?.LastName
          ? contactDetails?.LastName
          : "",
        invoice_number: notImportLogs[i]?.InvoiceNumber ? (
          notImportLogs[i]?.file ? (
            <Link
              onClick={() => downloadLetter(notImportLogs[i]?.file)}
              style={{
                textDecoration: "underline",
              }}
            >
              {notImportLogs[i]?.InvoiceNumber}
            </Link>
          ) : (
            notImportLogs[i]?.InvoiceNumber
          )
        ) : (
          "-"
        ),
        invoice_date: notImportLogs[i]?.Date ? notImportLogs[i]?.Date : "",
        due_date: notImportLogs[i]?.DueDate ? notImportLogs[i]?.DueDate : "",
        exc_gst_claimed_amount: notImportLogs[i]?.Total
          ? `$${formatNumber(
              Number(
                formatNumber(Number(notImportLogs[i]?.Total)).replace(
                  /,/g,
                  ""
                ) / 1.1
              )
            )}`
          : "$0.00",
        claimed_amount: notImportLogs[i]?.Total
          ? `$${formatNumber(Number(notImportLogs[i]?.Total))}`
          : "$0.00",

        amount_credit: notImportLogs[i]?.AmountCredited
          ? `$${formatNumber(Number(notImportLogs[i]?.AmountCredited))}`
          : "$0.00",
        amount_due: notImportLogs[i]?.AmountDue
          ? `$${formatNumber(Number(notImportLogs[i]?.AmountDue))}`
          : "$0.00",
        amount_paid: notImportLogs[i]?.AmountPaid
          ? `$${formatNumber(Number(notImportLogs[i]?.AmountPaid))}`
          : "$0.00",
        post_date: notImportLogs[i]?.Date ? notImportLogs[i]?.Date : "-",
        credit_note: creditNotes?.length > 0 ? creditNotes : "",
        status: (
          <>
            <PaymentClaimStatus
              id={notImportLogs[i]?.id}
              approve={1}
              email={
                notImportLogs[i]?.contact?.email
                  ? notImportLogs[i]?.contact?.email
                  : ""
              }
              fetchPaymnetClaims={() => fetchNotImportedLogs(limit, page)}
              projectId={projectId}
              trust_type={trust_type}
              ProjectReadOnly={ProjectReadOnly}
            />
          </>
        ),

        import_from: notImportLogs[i]?.import_from
          ? notImportLogs[i]?.import_from
          : "",
        import_date: (
          <span>
            {notImportLogs[i]?.updated_at
              ? moment(
                  notImportLogs[i]?.updated_at,
                  "DD-MM-YYYY HH:mm:SS"
                ).format("DD-MM-YYYY")
              : notImportLogs[i]?.created_at
              ? moment(
                  notImportLogs[i]?.created_at,
                  "DD-MM-YYYY HH:mm:SS"
                ).format("DD-MM-YYYY")
              : ""}
          </span>
        ),
        reason: notImportLogs[i]?.message ? notImportLogs[i]?.message : "-",

        action: (
          <>
            <FontAwesomeIcon
              icon={faEye}
              size="1x"
              onClick={() => handleDetails(notImportLogs[i]?.id)}
            />

            {/* <NotImportedDelete
              handleDelete={handleDelete}
              id={notImportLogs[i]?.id}
            /> */}

            {/* <>
              <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
              <FontAwesomeIcon
                icon={faEdit}
                onClick={() => toggleEditModal(notImportLogs[i]?.id)}
                size="1x"
              />
            </> */}
          </>
        ),
      });
    }
    return items;
  };

  const notImportLogsData = notImportLogsGenerator(notImportLogs?.length);

  const columns = [
    {
      dataField: "post_date",
      text: "Posted Date",
      style: {
        width: "110px"
      }
      // sort: true,
    },
    {
      dataField: "payment_claim_to",
      text: "Payment Claim By ",
      // sort: true,
    },
    {
      dataField: "invoice_number",
      text: "Invoice/Claim Number",
      // sort: true,
    },
    {
      dataField: "invoice_date",
      text: "Invoice/Claim Date",
      // sort: true,
    },
    {
      dataField: "due_date",
      text: "Due Date",
      style: {
        width: "100px"
      }
      // sort: true,
    },
    {
      dataField: "exc_gst_claimed_amount",
      text: "Claimed Amount (Ex. GST)",
      // sort: true,
    },
    {
      dataField: "claimed_amount",
      text: "Claimed Amount (Inc. GST)",
      // sort: true,
    },
    {
      dataField: "amount_credit",
      text: "Amount Credited",
      // sort: true,
    },
    {
      dataField: "amount_due",
      text: "Amount Due",
      // sort: true,
    },
    {
      dataField: "amount_paid",
      text: "Amount Paid",
      // sort: true,
    },
    {
      dataField: "import_date",
      text: "Import/Sync Date",
      style: { width: "10%" },
    },
    { dataField: "reason", text: "Reason" },
    {
      dataField: "action",
      text: "Action",
      className: "text-center",
      style: { width: "100px", textAlign: "center" },
      headerStyle: {
        textAlign: "center",
      },
    },
  ];

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchNotImportedLogs(limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchNotImportedLogs(limit, page);
  };

  // *Import Logs List Table Row and Column Generation, Filtering and Sorting of Record, Select Row and Expand Row - End

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    debouncedSave(nextValue);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    []
  );

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  return (
    <>
      <div className="table-top-btn">
        <SearchBox
          placeholder={"Search Not Imported Logs"}
          searchParamData={searchParamData}
          handleSearchChange={handleSearchChange}
          handleClearSearch={handleClearSearch}
        />
      </div>
      <div className="audit-statement">
        {loading && <Spin />}
        <BootstrapTable
          keyField="batch_id"
          remote
          data={notImportLogsData}
          columns={columns}
          noDataIndication="No Data Found"
          onTableChange={handleTableChange}
        />

        <Pagination
          total={total}
          limit={parseInt(limit)}
          currentPage={page}
          updateLimit={handleUpdateLimit}
          updatePage={handleChangePage}
          from={from}
          to={to}
        />
      </div>

      {importLogModal && (
        <ImportLogDetail
          toggleShowModal={toggleShowModal}
          importLogId={notImportLogId}
          importLogModal={importLogModal}
          projectId={projectId}
        />
      )}
      {showEdit && (
        <Modal
          size="lg"
          show={showEdit}
          onHide={toggleEditModal}
          dialogClassName="small-review payment-schedule-calender-modal payment-claim-edit-modal"
          aria-labelledby="contained-modal-title-vcenter"
          className="project-section"
          centered
        >
          <Modal.Header className="mb-0" closeButton>
            Edit Payment Claim
          </Modal.Header>
          <Modal.Body style={{ padding: "15px" }}>
            <Upload
              edit={true}
              id={notImportLogId}
              handleEditSucess={() => {
                toggleEditModal();
                fetchNotImportedLogs(limit, page);
              }}
              notImportLog={true}
            />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default NotImportedLogs;
